import Storage from '../Storage.js';

Storage.setConfig("fields", {
  config: {
    method: "fields/",
    title: "Поля",
    objectName: "Поле",
    adminGroup: true
  },
  properties: {
    id: {
      default: false,
      type: "text",
      title: "#",
      preset: true,
      width: "20px"
    },
    create_time: {
      default: "",
      type: "text",
      title: "Создан",
      preset: true,
      width: false
    },
    update_time: {
      default: "",
      type: "text",
      title: "Обновлен",
      preset: true,
      width: false
    },
    name: {
      default: "",
      type: "text",
      title: "Имя поля",
      preset: false,
      width: "auto"
    }
  }
});



// WEBPACK FOOTER //
// ./src/config/fields.js